import { useTranslation } from 'react-i18next'
import useUserContext from 'shared/users/contexts/useUserContext'
import { useCopilot } from '../hooks/useCopilot'
import { SessionState } from '../state/types'
import { stepLabel } from '../util/activity'

interface RunningStepProps { session: SessionState }

/** The live row for a run in flight: the "thinking" block every operator sees, carrying the Stop
 *  control. The step in progress rides along for admins only — the same label the ActivityLog draws
 *  for them. Never a method or path (T1-3895): the service no longer sends one. */
export function RunningStep({ session }: Readonly<RunningStepProps>) {
  const { t } = useTranslation()
  const { interrupt } = useCopilot()
  const { isAdmin } = useUserContext()
  const running = session.phase === 'streaming'
    || session.phase === 'awaiting_confirmation'
    || session.phase === 'awaiting_answer'
  if (!running) return null

  const step = session.timeline.find((i) => i.kind === 'tool' && i.status === 'running')
  const label = step && step.kind === 'tool' ? stepLabel(t, step) : null

  return (
    <div className="copilot-running">
      <i className="fa fa-spinner copilot-running__spin" aria-hidden="true" />
      <span className="copilot-running__label">{t('copilot.thinking')}</span>
      {isAdmin && label && (
        <span className="copilot-running__step" data-testid="copilot-running-step">{label}</span>
      )}
      <button
        type="button"
        data-testid="copilot-interrupt"
        className="copilot-running__stop"
        onClick={() => interrupt(session.clientId)}
      >
        {t('copilot.interrupt')}
      </button>
    </div>
  )
}
